import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Index from '@/views/Index.vue'
import LocalStorageService from "@/common/LocalStorageService";
import { registerService } from "@/common/RegisterService";

const localStorageService = LocalStorageService.getService();

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      meta: {
        requiresAuth: false
      },
      component: Index
    },

    {
      path: '/home',
      name: 'home',
      meta: {
        requiresAuth: true
      },
      component: Home
    },

    {
      path: '/timeout',
      name: 'timeout',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/Timeout.vue')
    },

    {
      path: '/register/cna',
      name: 'register-cna',
      meta: {
        requiresAuth: false
      },
      component: () => import('./views/cna-user/Register.vue')
    },

    {
      path: '/correct-unclaimed',
      name: 'correct-unclaimed',
      meta: {
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/cna-user/CorrectUnclaimed.vue')
    },

    {
      path: '/register/provider',
      name: 'register-provider',
      meta:{
        requiresAuth: false
      },
      component: ()=> import('./views/provider/Register.vue')
    },

    {
      path: '/register',
      name: 'register',
      meta: {
        requiresAuth: false
      },
      component: () => import('./views/Register.vue')
    },

    {
      path: '/register/endorsement',
      name: 'register-endorsement',
      meta: {
        requiresAuth: false
      },
      component: () => import('./views/cna-user/EndorsementApplication.vue')
    },

    {
      path: '/certificate-search',
      name: 'certificate-search',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/CertificateSearch.vue')
    },

    // {
    //   path: "/faq/process-chart",
    //   name: 'process-chart',
    //   meta: {
    //     requiresAuth: false,
    //   },
    //   component: () => import(/* webpackChunkName: "thanks" */ './views/faq/ProcessChart.vue')
    // },
    //
    // {
    //   path: "/faq/testing-out",
    //   name: 'testing-out',
    //   meta: {
    //     requiresAuth: false,
    //   },
    //   component: () => import(/* webpackChunkName: "thanks" */ './views/faq/TestingOut.vue')
    // },
    //
    // {
    //   path: "/faq/pay-stubs",
    //   name: 'pay-stubs',
    //   meta: {
    //     requiresAuth: false,
    //   },
    //   component: () => import(/* webpackChunkName: "thanks" */ './views/faq/Faq.vue')
    // },
    //
    // {
    //   path: "/faq/exceptions",
    //   name: 'exceptions',
    //   meta: {
    //     requiresAuth: false,
    //   },
    //   component: () => import(/* webpackChunkName: "thanks" */ './views/faq/Exceptions.vue')
    // },
    //
    // {
    //   path: "/faq/job-description",
    //   name: 'job-description',
    //   meta: {
    //     requiresAuth: false,
    //   },
    //   component: () => import(/* webpackChunkName: "thanks" */ './views/faq/JobDescription.vue')
    // },

    {
      path: "/faq",
      name: 'FAQ',
      meta: {
        requiresAuth: false
      },
      component: () => import('./views/faq/Faq.vue')
    },

    {
      path:"/facilityNAReportsAdmin",
      name:'facilityNAReportsAdmin',
      meta:{
        requiresAuth: true,
        authRoles: ['mdh-staff','mdh-admin']
      },
      component: () => import('./views/admin/reports/FacilityReports.vue')
    },
    {
      path: "/renew",
      name: 'renewalApplication',
      meta: {
        requiresAuth: true
      },
      component: () => import('./views/RenewalApplication.vue')
    },

    {
      path: "/edit-renewal/:id",
      name: 'editRenewal',
      meta: {
        requiresAuth: true,
        authRole: ['mdh-staff','mdh-admin']
      },
      component: ()=>import('./views/approval/EditRenewal.vue')
    },

    {
      path:"/credentialer-reports",
      name: "credentialerReports",
      meta: {
        requiresAuth: true,
        authRole: ['mdh-admin']
      },
      component: ()=>import('./views/admin/reports/CredentialerReports.vue')
    },

    {
      path: "/edit-endorsement/:id",
      name: 'editInterstate',
      meta: {
        requiresAuth: true,
        authRole: ['mdh-staff','mdh-admin']
      },
      component: () => import('./views/approval/EditEndorsement.vue')
    },
    // {
    //   path: "/application",
    //   name: 'application',
    //   meta: {
    //     requiresAuth: true,
    //   },
    //   component: () => import(/* webpackChunkName: "request" */ './views/cna-user/EditApplication.vue')
    // },
    //
    // {
    //   path: "/application/draft/:draftId",
    //   name: 'applicationDraft',
    //   meta: {
    //     requiresAuth: true,
    //   },
    //   component: () => import(/* webpackChunkName: "request" */ './views/cna-user/EditApplication.vue')
    // },

    {
      path: "/thanks",
      name: 'thanks',
      meta: {
        requiresAuth: false,
      },
      component: () => import(/* webpackChunkName: "thanks" */ './views/Thanks.vue')
    },

    {
      path: "/review-renewal/:id",
        name: 'review-renewal',
        meta: {
          requiresAuth: true,
          authRoles: ['mdh-staff','mdh-admin', 'readonly']
        },
      component: () => import(/* webpackChunkName: "approve" */ './views/approval/RenewalReview.vue')
    },
    {
      path: "/return-renewal/:id",
      name: 'return-renewal',
      meta:{
        requiresAuth: true,
        authRoles: ['mdh-staff', 'mdh-admin']
      },
      component: ()=> import ('./views/approval/RenewalRejection.vue')
    },

    {
      path: "/review-endorsement/:id",
      name: 'review-endorsement',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-staff','mdh-admin', 'readonly']
      },
      component: () => import(/* webpackChunkName: "approve" */ './views/approval/EndorsementReview.vue')
    },
    {
      path: "/review-staff-report/:id",
      name: 'review-staff-report',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-staff','mdh-admin']
      },
      component: () => import(/* webpackChunkName: "approve" */ './views/approval/SemiannualReview.vue')
    },
    {
      path: "/return-endorsement/:id",
      name: 'return-endorsement',
      meta:{
        requiresAuth: true,
        authRoles: ['mdh-staff','mdh-admin']
      },
      component: () => import('./views/approval/EndorsementRejection.vue')
    },
    {
      path: "/provider/users",
      name: 'provider-users',
      meta: {
        requiresAuth: true,
        authRoles: ['provider-admin']
      },
      component: ()=> import('./views/provider/AuthorizedUsers.vue')
    },

    {
        path: "/print-certificate",
        name: "print-certificate",
        meta:
        {
            requiresAuth: true,
            authRoles: ['cna', 'provider', "provider-admin"] //todo: check provider needs print access
        },
        component: () => import(/* webpackChunkName: "printCertificate" */ './components/templates/display/PrintCertificate.vue')
    },

    {
      path: "/review-change/:type/:id/:uuid",
      name: 'review-change',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-staff','mdh-admin']
      },
      component: () => import(/* webpackChunkName: "approve" */ './views/review/ChangeReview.vue')
    },

    {
      path: "/review-unclaimed-change/:id",
      name: 'review-unclaimed-change',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-staff','mdh-admin']
      },
      component: () => import(/* webpackChunkName: "approve" */ './views/review/UnclaimedChangeReview.vue')
    },

    {
      path: "/change-requests",
      name: 'change-requests',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-staff','mdh-admin']
      },
      component: () => import(/* webpackChunkName: "approve" */ './views/review/ChangeRequests.vue')
    },

    {
      path: "/view-renewal/:id",
      name: 'view-renewal',
      meta: {
        requiresAuth: true,
        // authRoles: ['interstate','cna']
      },
      component: () => import(/* webpackChunkName: "viewRenewal" */ './views/cna-user/ViewRenewal.vue')
    },
    {
      path: "/view-endorsement/:id",
      name: 'view-endorsement',
      meta: {
        requiresAuth: true,
        // authRoles: ['interstate','cna']
      },
      component: () => import('./views/interstate/ViewInterstate.vue')
    },
    {
      path: "/resubmit-renewal/:id",
      name: 'resubmit-renewal',
      meta: {
        requiresAuth: true,
        // authRoles: ['cna']
      },
      component:()=>import('./views/cna-user/ResubmitRenewal.vue')
    },
    {
      path: "/resubmit-endorsement/:id",
      name: 'resubmit-endorsement',
      meta: {
        requiresAuth: true
      },
      component:()=>import('./views/interstate/ResubmitInterstate.vue')
    },
    {
      path: "/FacilityNAReports",
      name: "FacilityNAReports",
      meta:{
        requiresAuth: true,
        authRoles: ['provider', 'provider-admin']
      },
      component:()=>import('./views/provider/Reports.vue')
    },
    {
      path: "/facilitySearch",
      name: "FacilitySearch",
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-staff','mdh-admin']
      },
      component:()=>import('./views/admin/FacilitySearch.vue')
    },
    {
      path: "/viewFacility/:id",
      name: "ViewFacility",
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-staff', 'mdh-admin']
      },
      component: ()=>import('./views/admin/ViewFacility.vue')
    },
    {
      path: "/viewUser/:id",
      name: "ViewUser",
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-staff', 'mdh-admin']
      },
      component: ()=>import('./views/admin/ViewUser.vue')
    },
    {
      path: "/userSearch",
      name: "UserSearch",
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-staff', 'mdh-admin']
      },
      component: ()=>import('./views/admin/UserSearch.vue')
    },
    {
      path: "/certificateMerge",
      name: "CertificateMerge",
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-admin']
      },
      component: ()=>import('./views/admin/CertificateMerge.vue')
    },
    {
      path: "/cna-report",
      name: 'cna-report',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-admin', 'mdh-staff']
      },
      component: () => import(/* webpackChunkName: "admin" */ './views/admin/reports/CnaReport.vue')
    },

    {
      path: "/credentialer",
      name: 'credentialer',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-admin']
      },
      component: () => import(/* webpackChunkName: "admin" */ './views/admin/Credentialer.vue')
    },

    {
      path: "/credentialer-assign/:id/:type",
      name: 'credentialer-assign',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-admin']
      },
      component: () => import(/* webpackChunkName: "admin" */ './views/admin/CredentialerAssign.vue')
    },

    {
      path: "/credentialer-search",
      name: 'credentialer-search',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-admin']
      },
      component: () => import(/* webpackChunkName: "admin" */ './views/admin/CredentialerSearch.vue')
    },

    // {
    //   path: "/claim",
    //   name: 'claim',
    //   meta: {
    //     requiresAuth: true,
    //   },
    //   component: () => import(/* webpackChunkName: "admin" */ './views/cna-user/ClaimApplication.vue')
    // },
    //
    {
      path: "/profile-info",
      name: 'profile-info',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "thanks" */ './views/cna-user/ProfileInfo.vue')
    },
    {
      path: "/profile-contact-update",
      name: 'profile-contact-update',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "thanks" */ './views/cna-user/ContactUpdate.vue')
    },
    {
      path: "/profile-name-update",
      name: 'profile-name-update',
      meta: {
        requiresAuth: true,
        authRoles: ['cna']
      },
      component: () => import(/* webpackChunkName: "thanks" */ './views/cna-user/NameUpdate.vue')
    },
    {
      path: "/profile-ssn-update",
      name: 'profile-ssn-update',
      meta: {
        requiresAuth: true,
        authRoles: ['cna']
      },
      component: () => import(/* webpackChunkName: "thanks" */ './views/cna-user/SsnUpdate.vue')
    },
    {
      path: "/profile-dob-update",
      name: 'profile-dob-update',
      meta: {
        requiresAuth: true,
        authRoles: ['cna']
      },
      component: () => import('./views/cna-user/DobUpdate.vue')
    },

    {
      path:"/profile-texting-preferences",
      name: 'profile-texting-preferences',
      meta:{
        requiresAuth: true,
      },
      component:() => import ('./views/cna-user/TextingPreferences.vue')
    },
    {
      path: "/report/error",
      name: 'error',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-admin','mdh-staff']
      },
      component: () => import(/* webpackChunkName: "thanks" */ './views/admin/reports/Error.vue')
    },
    {
      path: "/search-audit",
      name: 'search-audit',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-admin']
      },
      component: () => import(/* webpackChunkName: "thanks" */ './views/admin/reports/SearchAudit.vue')
    },
    //
    // {
    //   path: "/message/:id",
    //   name: 'message',
    //   meta: {
    //     requiresAuth: true,
    //   },
    //   component: () => import(/* webpackChunkName: "request" */ './views/cna-user/Message.vue')
    // },
    {
      path: "/announcementEmails",
      name: 'announcementEmails',
      meta:{
        requiresAuth:  true,
        authRoles: ['mnit-admin']
      },
      component: ()=> import('./views/mnit-admin/TriggerReleaseEmails.vue')
    },
    {
      path: '/unauthorized',
      name: 'unauthorized',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "unauthorized" */ './views/Unauthorized.vue')
    },

    {
      path: '*', 
      component: Home
    },

    {
      path: '/ieNotification',
      name: 'ieNotification',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "unauthorized" */ './views/IeNotification.vue')
    },

    {
      path: "/headmaster",
      name: 'headmaster',
      meta: {
      requiresAuth: true,
          authRoles: ['mdh-staff','mdh-admin', "mnit-admin"]
    },
      component: () => import(/* webpackChunkName: "approve" */ './views/admin/HeadmasterTrigger.vue')
    },
  ]
})

router.beforeEach((to, from, next) => {
  if(navigator.userAgent.match(/msie|trident/i) && to.name !== "ieNotification") {
    router.push("ieNotification")
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (router.app.$keycloak && router.app.$keycloak.authenticated) {
      if(!router.app.$keycloak.hasResourceRole('mdh-admin') && !router.app.$keycloak.hasResourceRole('mdh-staff')
          && !router.app.$keycloak.hasResourceRole('mnit-admin') && !router.app.$keycloak.hasResourceRole('readonly')
      && !router.app.$keycloak.hasResourceRole('provider-admin') && !router.app.$keycloak.hasResourceRole('provider')) {
        registerService.getProfile().then((p) => {
          if (!p) {
            if (to.name === "correct-unclaimed") {
              next();
            } else {
              router.push("register")
            }
          }
        })
      }
      if (to.meta.authRoles) {
        let hasRole = false
        for (var i = 0; i < to.meta.authRoles.length; i++) {
          if (router.app.$keycloak.hasResourceRole(to.meta.authRoles[i])) {
            hasRole = true;
          }
        }
        if (hasRole) {
          next()
        } else {
          router.push('unauthorized') 
        }
      } else {
        next();
      }
    } else {
      const url = localStorageService.getLoginUrl()
      window.location.replace(url)
    }
  } else {
    next()
  }
})

export default router